export default function ProblemSection() {
  return (
    <section className="relative py-16 md:py-20 lg:py-24 bg-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
              Why Most Product
              <br />
              Research Fails
              <br />
              <span className="text-primary-500">Without Structure</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-5 leading-relaxed max-w-lg">
              Most sellers struggle with scattered product data across platforms,
              slow manual research processes, no structured comparison system,
              and missed winning products due to lack of insights. Traditional
              methods are simply too slow for modern e-commerce.
            </p>

            <div className="grid grid-cols-3 gap-0 mt-10 border-t border-background-200/70 pt-10">
              <div className="text-center px-3">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">
                  14+
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 leading-snug">
                  Product Categories
                  <br />
                  Covered
                </p>
              </div>
              <div className="text-center px-3 border-x border-background-200/60">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">
                  100%
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 leading-snug">
                  Real-time Supplier
                  <br />
                  Links
                </p>
              </div>
              <div className="text-center px-3">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">
                  10x
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 leading-snug">
                  Faster Sourcing
                  <br />
                  Speed
                </p>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative h-[400px] w-full rounded-2xl overflow-hidden bg-primary-50/60">
              <div className="absolute top-8 left-8 w-32 h-32 rounded-3xl bg-primary-200/40 rotate-12"></div>
              <div className="absolute top-20 right-12 w-24 h-24 rounded-full bg-primary-300/30"></div>
              <div className="absolute bottom-12 left-16 w-40 h-40 rounded-2xl bg-primary-100/50 -rotate-6"></div>
              <div className="absolute bottom-20 right-8 w-28 h-36 rounded-3xl bg-primary-200/35 rotate-45"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-2xl bg-primary-400/25"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}